<template>
  <!--    main-->
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">담당자 이름<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactName">
                    </label>
                    <div class="hint on" v-show="$v.params.contactName.$error">{{ valid.msg.contactName }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">담당자 부서</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="params.contactDepartment">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">담당자 E-Mail<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactEmail">
                    </label>
                    <div class="hint on" v-show="$v.params.contactEmail.$error">{{ valid.msg.contactEmail }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자 연락처<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="number" placeholder="휴대폰 번호 입력" v-model="params.contactPhone" @input="numberOnly(params.contactPhone, 'contactPhone')" maxlength="11">
                    </label>
                    <button class="btn type_02" @click="sendPhoneAuth">{{ sendPhoneAuthText }}</button> <!--노란색 버튼은 type_02-->
                  </div>
                  <div class="inline" v-show="isSendAuth">
                    <label class="input timer">
                      <input type="number" placeholder="인증코드 입력" v-model="params.authCode" @input="numberOnly(params.authCode, 'authCode')" maxlength="4" :disabled="isConfirmAuth">
                      <span class="time" v-show="!isConfirmAuth">{{ timer }}</span>
                    </label>
                    <button class="btn type_02" @click="confirmPhoneAuthCode">확인</button> <!--노란색 버튼은 type_02-->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">담당자 연락처(직통번호)</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="params.contactTel">
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="{'on': isConfirmAuth}" @click="complete">변경하기</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>

import {required} from "vuelidate/lib/validators";

export default {
  data: function () {
    return {
      valid: {
        msg: {}
      },
      expired: false,
      timer: '5:00',
      sendPhoneAuthText: '인증',
      countDownInterval: null,
      isSendAuth: false,
      isConfirmAuth: true,
      findUserID: '',
      params: {
        contactName: this.$store.getters['account/getUserData'].contactName,
        contactDepartment: this.$store.getters['account/getUserData'].contactDepartment,
        contactEmail: this.$store.getters['account/getUserData'].contactEmail,
        contactPhone: this.$store.getters['account/getUserData'].contactPhone,
        contactTel: this.$store.getters['account/getUserData'].contactTel,
        authCode: '',
        authToken: ''
      }
    }
  },
  validations: {
    params: {
      contactName: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactName = '필수 항복 입니다.'
            return false
          }
          return true
        }
      },
      contactEmail: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactEmail = '필수 항복 입니다.'
            return false
          }
          return true
        }
      }
    }
  },
  computed: {
    userData: function() {
      return this.$store.getters['account/getUserData']
    }
  },
  watch: {
    'params.contactPhone': function () {
      this.isConfirmAuth = false
    },
  },
  methods: {
    numberOnly: function (value, type) {
      switch (type) {
        case 'userPhone':
          this.isConfirmAuth = false
          this.isSendAuth = false
          this.timer = '5:00'
          this.params.authCode = ''

          this.params.userPhone = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 11)
          break
        case 'authCode':
          this.params.authCode = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 4)
          break
      }
    },
    /**
     * 휴대폰 인증번호 확인
     */
    confirmPhoneAuthCode: function () {
      if (this.expired) {
        this.$Util.modalAlert({message: '인증시간이 만료되었습니다.<br>재 인증 해주세요.'})
        return false
      }

      if(this.params.authCode.length <= 0) {
        this.$Util.modalAlert({message: '인증코드를 입력해주세요.'})
        return false
      }

      let params = {
        contactPhone: this.params.contactPhone,
        authCode: this.params.authCode,
        authToken: this.params.authToken
      }

      this.$CommonSvc.confirmPhoneAuthCode(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log(entity)
          if (code === 1) {
            this.$Util.modalAlert({message: '인증 되었습니다.'})
            this.isConfirmAuth = true
            clearInterval(this.countDownInterval)
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    /**
     * 휴대폰 인증번호 발송
     */
    sendPhoneAuth: function () {
      if(this.params.contactPhone.length <= 0) {
        this.$Util.modalAlert({message: '휴대폰번호를 입력해주세요.'})
        return false
      }

      if(!this.$Util.isPhoneValid(this.params.contactPhone)) {
        this.$Util.modalAlert({message: '올바른 휴대폰번호를 입력해주세요.'})
        return false
      }

      let params = {
        authType: 4,
        contactPhone: this.params.contactPhone
      }

      this.$CommonSvc.sendPhoneAuth(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            // TODO 알럿 교체 (테스트용 코드 노출)
            // this.$Util.modalAlert({message: '인증코드가 발송 되었습니다. [' + entity['authCode(DEBUG)'] + ']'})
            this.$Util.modalAlert({message: '인증코드가 발송 되었습니다.'})
            this.params.authToken = entity.authToken
            this.params.authCode = ''
            this.isConfirmAuth = false
            this.isSendAuth = true
            this.sendPhoneAuthText = '재인증'
            this.expired = false
            this.timer = '5:00'
            this.countDown()
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    countDown: function () {
      clearInterval(this.countDownInterval)
      let duration = this.$moment.duration({
        'minutes': '5',
        'seconds': '00'
      })
      const _this = this
      this.countDownInterval = setInterval(function () {
        duration = _this.$moment.duration(duration.asSeconds() - 1, 'seconds')
        let min = duration.minutes()
        let sec = duration.seconds()
        if (Number(sec) < 0) {
          _this.timer = '0:00'
          _this.expired = true
          clearInterval(_this.countDownInterval)
          return false
        }
        if (sec < 10) {
          sec = '0' + sec
        }

        _this.timer = min + ':' + sec
      }, 1000)
    },
    complete: function () {
      if (!this.$Util.isValid(this.$v, this.$el)) return false

      if (!this.isConfirmAuth) {
        this.$Util.modalAlert({message: '인증절차를 완료 해주세요.'})
        return false
      }

      this.$AccountSvc.modifyContact(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            const _this = this
            this.$Util.modalAlert({message: '변경 되었습니다.'}, function () {
              setTimeout(function () {
                _this.$Util.refreshUserData(function () {
                  _this.$router.go(-1)
                })
              }, 200)
            })
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    }
  }
}
</script>
<style scoped>
.required {
  color: red;
}
</style>
